import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ReferralWiringInformationStore } from '../stores/referralWiringInformationStore';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { ReferralWiringInformationSignatureSigned } from './referralWiringInformationSignatureSigned';
import { ReferralWiringInformationSignatureForm } from './referralWiringInformationSignatureForm';
import { useEffect } from 'react';
import { useBorrowerPortalStore } from '../../../../apps/borrower-portal-v2/src/app/hooks';

const useStyles = makeStyles(theme => createStyles({}));

export type ReferralWiringInformationSignatureProps = {
  store: ReferralWiringInformationStore;
};
export const ReferralWiringInformationSignature = observer(
  (props: ReferralWiringInformationSignatureProps) => {
    const { store } = props;
    const classes = useStyles();

    return (
      <Grid container item xs={12}>
          <ReferralWiringInformationSignatureForm store={store} />
      </Grid>
    );
  }
);
